export function formatProductTitle(title: string) {
  return title
    .replace(/(\d\d\.\d\d% off )?auto renew$/i, '')
    .replace('&amp;', '&')
}
